/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import PaginasEspecificas from '../../../../components/paginasEspecificas';

function Experiencias() {
  return (
    <PaginasEspecificas posicao="21" endereco="/fisica" materia="Física" />
  );
}

export default Experiencias;
